module.exports = __webpack_public_path__ + "static/media/check.dc756be3.svg";